import React from 'react';

import PropTypes from 'prop-types';

import styled from 'styled-components';

import promoMedia from 'apps/promo/theme/promoMedia';

const ContainerWide = styled.div`
    margin-left: auto;
    margin-right: auto;
    max-width: 432px;
    padding-left: 20px;
    padding-right: 20px;

    ${promoMedia.tablet744} {
        max-width: 664px;
        padding-left: 40px;
        padding-right: 40px;
    }

    ${promoMedia.desktop1440} {
        max-width: 1080px;
        padding-left: 180px;
        padding-right: 180px;
    }
`;
const ContainerNarrow = styled.div`
    margin-left: auto;
    margin-right: auto;
    max-width: 432px;
    padding-left: 20px;
    padding-right: 20px;
    width: calc(100% - 40px);

    ${promoMedia.tablet744} {
        max-width: 504px;
        padding-left: 120px;
        padding-right: 120px;
    }

    ${promoMedia.desktop1440} {
        max-width: 1080px;
        padding-left: 180px;
        padding-right: 180px;
    }
`;
const ContainerAverage = styled.div`
    margin-left: auto;
    margin-right: auto;
    max-width: 432px;
    padding-left: 20px;
    padding-right: 20px;

    ${promoMedia.tablet744} {
        max-width: 504px;
        padding-left: 120px;
        padding-right: 120px;
    }

    ${promoMedia.desktop1440} {
        max-width: 888px;
        padding-left: 180px;
        padding-right: 180px;
    }
`;

export const PromoSectionContainer = ({ dimension = 'narrow', ...props }) => {
    return (
        <>
            {dimension === 'wide' && <ContainerWide>{props.children}</ContainerWide>}
            {dimension === 'narrow' && <ContainerNarrow>{props.children}</ContainerNarrow>}
            {dimension === 'average' && <ContainerAverage>{props.children}</ContainerAverage>}
        </>
    );
};

PromoSectionContainer.propTypes = {
    children: PropTypes.any,
    dimension: PropTypes.oneOf(['wide', 'narrow', 'average']),
};
